export function getQuerystringNameValue(name: string): string | null {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
}

function toggleReadspeakerToolbar() {
    setTimeout(() => {
        if (window.innerWidth < 768) { return; }
        const panel = document.getElementById('__bs_entryDiv');
        if (panel) { document.body.classList.add('readspeaker-toolbar-open'); }
    }, 500);
}

window.onload = toggleReadspeakerToolbar;
